<template>
  <div>
    <b-card>
      <b-card-body>
        <validation-observer ref="EditServiceTemplate" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted" @change="formChanged()">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Template Name*"
                  label-for="mc-Template-name"
                >
                  <validation-provider
                    rules="required|alphanumeric_spaces|min:3|max:100"
                    #default="{ errors }"
                    :customMessages="{
                      min: 'The Template Name must be at least 3 character(s).',
                    }"
                    name="Template Name"
                    vid="Template Name"
                  >
                    <b-form-input
                      id="mc-Template-name"
                      type="text"
                      required
                      placeholder="Enter your template name"
                      v-model="ServiceTemplateObject.orderName"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Description"
                  label-for="mc-Template-Description"
                >
                  <validation-provider
                    rules="min:3|max:250"
                    #default="{ errors }"
                    :customMessages="{
                      min: 'The Description must be at least 3 character(s).',
                    }"
                    name="Description"
                    vid="Description"
                  >
                    <b-form-input
                      type="text"
                      id="mc-Template-Description"
                      placeholder="Enter your description"
                      v-model="ServiceTemplateObject.orderDescription"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Selling Price" label-for="mc-Budget">
                  <validation-provider
                    rules="required|price_Validation|min:1|min_value:0"
                    #default="{ errors }"
                    name="SellingPrice"
                    vid="SellingPrice"
                  >
                    <b-form-input
                      id="mc-Budget"
                       step="0.01"
                      placeholder="Enter your selling price"
                      type="number"
                      v-model="ServiceTemplateObject.budget"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Estimated Duration (In Hours)"
                  label-for="mc-Estimated-Duration"
                >
                  <validation-provider
                    rules="numeric_decimal|min_value:0"
                    #default="{ errors }"
                    name="Estimated Duration"
                    vid="Estimated Duration"
                  >
                    <b-form-input
                      id="mc-Estimated-Duration"
                      placeholder="Enter your estimated duration"
                      type="number"
                      v-model="ServiceTemplateObject.estimatedDuration"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Staff*" label-for="mc-staff">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Staff"
                    vid="Staff"
                  >
                    <v-select
                      taggable
                      multiple
                      push-tags
                      placeholder="Add staff"
                      label="name"
                      menu-props="{ auto: true, offsetY: true, maxHeight: '200px' }"
                      attach="body"
                      v-model="selectedStaff"
                      :options="staffpopulate"
                    />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-col md="12" class="d-flex justify-content-between">
              <b-button type="submit" variant="primary" :disabled="loading"
                ><b-spinner small v-if="loading" class="mx-2" />Submit</b-button
              >
            </b-col> -->
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <validation-observer ref="addProduct">
      <!-- modal Add Item-->
      <b-modal
        id="modal-addProduct"
        :hide-footer="true"
        ref="addProductModal"
        centered
        title="Add Product"
      >
        <b-form @submit.prevent="handleProdSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="name">Name:</label>
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="name"
                >
                  <b-form-input
                    id="name"
                    type="text"
                    placeholder="Name"
                    v-model="products.ProductId"
                    required
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="qty">Quantity:</label>
                <validation-provider
                  rules="required|numeric|min_value:0"
                  #default="{ errors }"
                  name="qty"
                >
                  <b-form-input
                    id="qty"
                    type="number"
                    placeholder="Quantity"
                    v-model="products.Quantity"
                    required
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <!--    <b-col cols="3">
         Button Add Item 
       <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
          Close
        </b-button> 
      </b-col> -->
            <b-col cols="auto">
              <!-- Button Add Item -->
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                @click="addProduct"
              >
                Save
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>

    <!-- Items Section -->
    <b-card v-if="HasPermission(PermissionList.Inventory_Create)">
      <b-row>
        <b-col>
          <h3 class="mb-2">Item Details</h3>
        </b-col>
      </b-row>
      <div ref="itemForm" class="repeater-form" :style="{ height: itemFormHeight }">
        <b-row
          v-for="(item, index) in invoiceData.items"
          :key="index"
          ref="row"
          class="align-items-center border rounded m-0 mb-2 p-2"
        >
          <b-col cols="12" sm="6" md="6">
            <v-select
              v-model="item.id"
              :options="optionsProduct"
              label="itemTitle"
              placeholder="Select Item"
              append-to-body
              menu-props="{ auto: true, offsetY: true, maxHeight: '200px' }"
              attach="body"
              @input="(val) => updateItemForm(index, val)"
            />
          </b-col>

          <!-- Quantity Input -->
          <b-col cols="12" sm="4" md="4">
            <b-form-input
              v-model="item.qty"
              type="number"
              min="1"
              step="1"
              @input="autoCorrectQty"
              @keypress="onlyDigits"
            ></b-form-input>
          </b-col>
          
          

          <b-col
            cols="12"
            sm="2"
            md="1"
            class="d-flex justify-content-center align-items-center"
          >
            <b-button
              size="sm"
              variant="outline-danger"
              class="d-flex align-items-center px-2"
              @click="removeItem(index, 'item')"
            >
              <span class="mr-1">&times;</span> Delete
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row class="align-items-center">
        <b-col md="2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="primary"
            class="mt-2 mr-2"
            @click="addNewItemInItemForm"
          >
            Add Item
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-body>
        <b-row>
          <b-col>
            <h3 class="mb-2">Tasks Details*</h3>
          </b-col>
        </b-row>
        <div>
          <div>
            <validation-observer ref="EditServiceTemplateDetails">
              <b-form
                ref="taskForm"
                :style="{ height: taskFormHeight }"
                class="repeater-form"
              >
                <b-row
                  v-if="items.length > 0"
                  v-for="(item, index) in items"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                  class="mb-2"
                >
                  <!-- Tasks -->
                  <b-col md="4">
                    <b-form-group label="Tasks*" label-for="item-tasks">
                      <validation-provider
                        rules="required|min:3|max:250"
                        :customMessages="{
                          min: 'task must be at least 3 character(s).',
                        }"
                        v-slot="{ errors, validate }"
                        ref="taskProvider"
                        :vid="'task_' + index"
                        name="Tasks"
                        class="mb-4"
                      >
                        <b-form-input
                          :id="`item-tasks_${index}`"
                          type="text"
                          placeholder="Enter your tasks"
                          v-model="item.tasks"
                          @blur="validate"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Resources -->
                  <b-col md="2">
                    <b-form-group label="Resources*" label-for="resources">
                      <validation-provider
                        rules="required|min:0|max:250"
                        v-slot="{ errors, validate }"
                        ref="resourcesProvider"
                        :vid="'resources_' + index"
                        name="Resources"
                      >
                        <b-form-input
                          :id="`resources_${index}`"
                          type="text"
                          placeholder="Enter your resources"
                          v-model="item.resources"
                          @blur="validate"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Tools -->
                  <b-col md="2">
                    <b-form-group label="Tools*" label-for="tools">
                      <validation-provider
                        rules="required|min:0|max:250"
                        v-slot="{ errors, validate }"
                        ref="toolsProvider"
                        :vid="'tools_' + index"
                        name="Tools"
                      >
                        <b-form-input
                          :id="`tools_${index}`"
                          type="text"
                          placeholder="Enter your tools"
                          v-model="item.tools"
                          @blur="validate"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Cost -->
                  <b-col lg="2" md="1">
                    <b-form-group label="Cost*" label-for="price">
                      <validation-provider
                        rules="required|numeric_decimal|min_value:0.01"
                        v-slot="{ errors, validate }"
                        ref="priceProvider"
                        :vid="'price_' + index"
                        name="Price"
                      >
                        <b-form-input
                          :id="`price_${index}`"
                          type="number"
                          placeholder="Enter your price"
                          v-model="item.price"
                          @blur="validate"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Remove Button -->
                  <b-col lg="2" md="3" class="mb-50">
                    <b-button
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeItem(index, 'task')"
                    >
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12" v-if="items.length > 1">
                    <hr />
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="AddNew"
            class="mt-1"
          >
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add New</span>
          </b-button>
          <b-row>
            <b-col cols="12" style="text-align: right">
              <b-button
                variant="outline-primary"
                class="btn btn-primary"
                @click="formSubmitted()"
                >Update</b-button
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-body>
        <DocumentUpload
          @deleteFile="deleteFile"
          @downloadFile="downloadFile"
          @uploadFiles="uploadFiles"
          :documentDetails="documentDetails"
        />
        <!-- <ServiceTemplateUpload  @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
           @documentDetails="documentDetails" /> -->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BForm,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormCheckbox,
  BFormFile,
  BContainer,
  BCard,
  BCardBody,
  BCardText,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import vSelect from "vue-select";
import { fnSortingDropdown } from "@/libs/customFn";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  deleteDocumentS,
  uploadMultipleDocuments,
  uploadDocument,
  downloadDocument,
} from "@/store/documentrepo/services";
import DocumentUpload from "../../../component/DocumentUpload.vue";
//import ServiceTemplateUpload from "../../../component/ServiceTemplateUpload.vue";
import "@/libs/customValidation";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";
export default {
  components: {
    BFormSelect,
    BFormFile,
    BFormGroup,
    BForm,
    BFormTextarea,
    BFormInput,
    FormWizard,
    BContainer,
    BButton,
    BFormCheckbox,
    BCardBody,
    BCard,
    TabContent,
    BRow,
    BCol,
    ToastificationContent,
    BCardText,
    BSpinner,
    quillEditor,
    DocumentUpload,
    //ServiceTemplateUpload,
    required,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      itemFormHeight: null,
      taskFormHeight: null,
      processingData: null,
      id: this.$route.params.id,
      orderName: null,
      orderDescription: null,
      budget: null,
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      defaultItem: [
        {
          id: 0,
          tasks: null,
          resources: null,
          tools: null,
          price: 0.0,
        },
      ],
      items: [
        {
          id: 1,
          tasks: null,
          resources: null,
          tools: null,
          price: 0.0,
        },
      ],
      nextTodoId: 1,
      //documentDetails: []
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      optionsProduct: [],
      item: {
        qty: 1,
      },
      // add product modal
      prodName: "",
      prodQty: null,
      newProd: false,
      //currencyList: CurrencySymbols,
      selectedCurrency: "MUR",
      currencyOptions: [],
      staffOption: [],
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      exchangeRate: 1,
      barcode: null,
      loadingButton: false,
      selectedProduct: null,
      products: [],
      invoiceData: {
        items: [],
      },
    };
  },
  watch: {
    "ServiceTemplateObject.budget"(val) {
      if (val === "" || val === null) {
        //this.ServiceTemplateObject.budget = 0;
      }
    },
    "ServiceTemplateObject.estimatedDuration"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.estimatedDuration = 0;
      }
    },
  },
  methods: {
    ...mapActions("serviceModule", [
      "updateServiceTemplateAction",
      "getServiceTemplateByIDAction",
      "getServiceTemplateFileListAction",
      "postServiceTemplateDocumentAction",
      "getStaffForTemplateListAction",
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
      "getProductIDAction",
    ]),
    onlyDigits(event) {
      // Allow only digits (0-9)
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    autoCorrectQty(value) {
      // Remove non-digit characters
      let cleaned = String(value).replace(/\D/g, '');

      // Convert to number and ensure it's at least 1
      let number = parseInt(cleaned, 10);
      if (isNaN(number) || number <= 0) {
        number = 1;
      }

      this.item.qty = number;
    },
    getProductNameById(productId) {
      const product = this.ProductList.find((p) => p.id === productId);
      return product ? product.name : "Unknown Product";
    },

    showSuccess() {
      this.$swal({
        title: "Service Template Updated!",
        text: "You have successfully Updated a Service Template!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        this.$router.push({ name: "templates-list" });
      });
    },
    showProcessingDialog(text = "Please wait while the data is being loaded") {
      this.processingData = this.$swal({
        title: "Processing...",
        text: text,
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
    },
    hideProcessingDialog() {
      if (this.processingData) {
        this.processingData.close();
        this.processingData = null;
      }
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFiles = file; // Assign the file directly
        //this.$refs.fileInput.$el.value = '';  // Reset input
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrc = e.target.result;
          console.log("thisImage", this.imageSrc);
        };
        reader.readAsDataURL(file);
        console.log("thisImage", this.imageSrc);
        this.fileSizeError = null; // Reset any errors
      }
    },

    copyToClipboard(id) {
      const fileUrl = this.getFileUrl(id);
      navigator.clipboard.writeText(fileUrl).then(
        () => {
          this.$swal({
            title: "URL Copied!",
            text: "The file URL has been copied to your clipboard.",
            icon: "success",
            confirmButtonText: "OK",
          });
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
          this.$swal({
            title: "Error!",
            text: "Failed to copy the URL. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    },

    getFileUrl(id) {
      return `${process.env.VUE_APP_API_URL}v1/filesharings/download/${id}`;
    },

    // downloadFile(id, fileName) {
    //             const imageUrl = this.getFileUrl(id);
    //             console.log("idddddddddddddddd",id);
    //          console.log("filenamessssssssssssss",fileName);
    //          console.log("urlllllllllllllllllllllllll",imageUrl);
    //     const link = document.createElement('a');
    //     link.href = imageUrl; // URL of the image
    //     link.download = fileName; // Name to save the file as
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   },

    async downloadFile(id, fileName) {
      const document = this.documents.find(
        (documents) => documents.fileName === fileName
      );

      // console.log("iddddddddddddd", document.documentReferenceId);
      // console.log("filenameeeeeeeeee", fileName);

      id = document.documentReferenceId;

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          //loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      let docForm = new FormData();
      docForm.append("ServiceTemplateId", this.ServiceTemplateObject.id);
      console.log("Files: ", selectedFiles);
      //docForm.append("File", selectedFiles); //todo after api fix send Files
      selectedFiles.forEach((file) => {
        docForm.append("File", file);
        console.log("File: ", file); // The key "File" matches the property in your payload
      });
      await this.postServiceTemplateDocumentAction(docForm)
        .then((response) => {
          customSwal("Your file(s) have been successfully uploaded.");
          loader.close();
        })
        .catch((error) => {
          customError(error);
          loader.close();
        });

      await this.getServiceTemplateFileListAction(this.id).then(() => {
        this.documentDetails.documentList = this.documents;
        this.documentDetails.isDelete = true;
        console.log("item docs", this.documents);
      });
      loader.close();
    },

    async deleteFile(id) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteDocumentS(id)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal();
          this.getServiceTemplateFileListAction(this.id).then(() => {
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      //console.log("item docs", this.documents);
    });
        })
        .catch((error) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customError(error);
        });

      await this.getDocumentListAction(this.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-testdocument");
      });
    },
    formChanged() {},

    async formSubmitted() {
      console.log("formSubmitted triggered");
      const isValidMainForm = await this.$refs.EditServiceTemplate.validate();
      const isValidSubForm =
        !HasPermission(PermissionList.Inventory_Create) ||
        (await this.$refs.EditServiceTemplateDetails.validate());
      console.log(
        "🚀 ~ file: TemplateEdit.vue:858 ~ formSubmitted ~ isValidMainForm:",
        isValidMainForm,
        isValidSubForm
      );
      const hasValue = this.items.length > 0 ? true : false;
      if (!hasValue) {
        customError("Please provide at least one template detail");
        return;
      }

      if (isValidMainForm && isValidSubForm) {
        let details = [];
        if (this.items != null && this.items.length > 0) {
          this.items.forEach((detail, index) => {
            var obj = {};
            obj["OrderDetailTemplateId"] = detail.id;
            obj["Tasks"] = detail.tasks;
            obj["Resources"] = detail.resources;
            obj["Tools"] = detail.tools;
            obj["Price"] = detail.price;
            details.push(obj);
          });
        } else {
          details = null;
        }
        const staffIds = this.selectedStaff.map((staff) => staff.id).join(",");

        const mappedProducts = this.invoiceData.items
          .map((item) => {
            const ProductId = item.value || (item.id && item.id.value);
            const Quantity = item.qty;
            // Return an object only if ProductId exists
            return ProductId ? { ProductId, Quantity } : null;
          })
          .filter((item) => item !== null); // Filter out null values

        let payload = {
          OrderTemplateId: this.ServiceTemplateObject.id,
          OrderName: this.ServiceTemplateObject.orderName,
          OrderDescription: this.ServiceTemplateObject.orderDescription,
          Budget: this.ServiceTemplateObject.budget,
          StaffId: staffIds,
          EstimatedDuration: this.ServiceTemplateObject.estimatedDuration,
          OrderTemplateDetails: details,
          OrderTemplateProducts: mappedProducts,
        };
        console.log("editPayload", payload);

        this.ServiceTemplateObject.orderTemplateDetails = this.items;
        this.ServiceTemplateObject.OrderTemplateProducts = mappedProducts;
        this.showProcessingDialog(
          "Please wait while the data is being process"
        );
        this.updateServiceTemplateAction({ payload })
          .then(() => {
            this.hideProcessingDialog();
            this.showSuccess();
            // customSwal("Service Template updated!");
          })
          .catch((ex) => {
            customError(ex);
          });
      } else {
        customError("Please fill out all required fields.");
      }
    },
    AddNew() {
      const dynamicValue =
        this.defaultItem.length > 0 ? this.defaultItem[0] : null;
      if (dynamicValue) {
        const clonedValue = { ...dynamicValue }; // Clone the default item to avoid reference issues
        this.items.push(clonedValue);

        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0]?.offsetHeight || 0);
        });
      }
    },
    removeItem(index, type) {
      if (type === "task") {
        // Remove a task from the tasks list
        this.items.splice(index, 1);
      } else if (type === "item") {
        // Remove an item from the invoiceData list
        this.invoiceData.items.splice(index, 1);
      }
      // Adjust the height after removal
      this.trTrimHeight(this.$refs.row[0]?.offsetHeight || 0);
    },
    // removeItem(index) {
    //   this.items.splice(index, 1);
    //   this.trTrimHeight(this.$refs.row[0].offsetHeight);
    // },

    // removeItem(index, type) {
    //   if (type === "item") {
    //     this.invoiceData.items.splice(index, 1);
    //   } else if (type === "task") {
    //     this.items.splice(index, 1);
    //   }

    //   this.$nextTick(() => {
    //     // Adjust heights dynamically after removing an item
    //     if (type === "item" && this.invoiceData.items.length === 0) {
    //       this.itemFormHeight = "auto";
    //     } else if (type === "task" && this.items.length === 0) {
    //       this.taskFormHeight = "auto";
    //     }

    //     setTimeout(() => {
    //       this.adjustHeight(type);
    //     }, 0); // Allow DOM updates before recalculating height
    //   });
    // },

    adjustHeight(type) {
      this.$nextTick(() => {
        console.log(" this.invoiceData", this.invoiceData);
        if (type === "item" && this.$refs.itemForm) {
          console.log(" this.invoiceData", this.invoiceData);
          this.itemFormHeight =
            this.invoiceData.items.length > 0
              ? `${this.$refs.itemForm.scrollHeight}px`
              : "0px"; // Set height to 0 if no items remain
        } else if (type === "task" && this.$refs.taskForm) {
          this.taskFormHeight =
            this.items.length > 0
              ? `${this.$refs.taskForm.scrollHeight}px`
              : "0px"; // Set height to 0 if no tasks remain
        }
      });
    },

    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.taskForm.scrollHeight);
        this.trSetHeight(this.$refs.itemForm.scrollHeight);
      });
    },
    async loadProductList() {
      console.log("this.productlist",this.ProductList);
      await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
            });
          }
        });
      });
      console.log("optionsProduct", this.optionsProduct);

      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },

    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    addProductFromModal(selectedProductId) {
      let selectedProduct = this.ProductList.find(
        (product) => product.id === selectedProductId
      );

      if (selectedProduct) {
        this.invoiceData.items.push({
          id: selectedProduct.id,
          name: `${selectedProduct.name}`,
          qty: 1,
        });

        this.item.id = selectedProduct.id;

        // Hide the modal
        this.$bvModal.hide("modal-barcode");

        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0].offsetHeight);
          setTimeout(() => {
            this.$refs.form.style.overflow = null;
          }, 350);
        });
      }
    },
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  beforeMount() {},
  async mounted() {
    this.showProcessingDialog("Please wait while the data is being loaded");

    if (HasPermission(PermissionList.Inventory_Create)) {
     // await this.getProductListAction(true);
     await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
            });
          }
        });
      });
    }

    await this.getServiceTemplateByIDAction(this.id).then(() => {
      this.items = this.ServiceTemplateObject.orderTemplateDetails ?? [];
      // this.products = this.ServiceTemplateObject.serviceOrderProducts ?? [];

      console.log(" this.invoiceData", this.invoiceData);
      this.invoiceData.items = (
        this.ServiceTemplateObject.orderTemplateProducts ?? []
      ).map((product) => {
        const matchingProduct = this.ProductList.find(
          (p) => p.id === product.productId
        );

        return {
          id: {
            value: product.productId,
            itemTitle: matchingProduct
              ? matchingProduct.name
              : "Unknown Product",
          },
          name: matchingProduct ? matchingProduct.name : "Unknown Product",
          qty: product.quantity,
          price: product.price, // Include price if you want to display it
        };
      });
    });
    await this.getServiceTemplateFileListAction(this.id).then(() => {
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      //console.log("item docs", this.documents);
    });
    await this.getStaffForTemplateListAction().then(() => {
      this.staffoption = this.staffList;
      this.staffpopulate = this.staffoption.map((option) => ({
        id: option.id,
        name: option.firstName + option.lastName,
      }));
    });

    console.log("this.productlist",this.ProductList);

    if (
      HasPermission(PermissionList.Inventory_Create) &&
      (this.ProductList == undefined || this.ProductList.length == 0)
    ) {
      //await this.getProductListAction(true);
      await this.loadProductList();
    }

    // this.invoiceData.items = this.products
    //   .map((item) => {
    //     const id = item.ProductId.value;
    //     const name = item.ProductId.itemTitle;
    //     const qty = item.Quantity;

    //     // Return an object only if ProductId exists
    //     return id ? { id, name, qty } : null;
    //   })
    //   .filter((item) => item !== null); // Filter out null values
    // this.ServiceTemplateObject.orderTemplateProducts.forEach((product) => {
    //   const matchingProduct = this.ProductList.find(
    //     (p) => p.id === product.productId
    //   );

    //   if (matchingProduct) {
    //     product.productId = {
    //       productId: product.productId,
    //       itemTitle: matchingProduct.name,
    //     };
    //   }
    // });

    this.initTrHeight();
    this.hideProcessingDialog();
  },
  setup() {
    const itemFormBlankItem = {
      id: null,
      name: null,
      qty: 1,
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    // const updateItemForm = (index, val) => {
    //   const { qty, value } = val;
    //   invoiceData.value.items[index].qty = val.qty;
    //   invoiceData.value.items[index].value = val.value;
    // };

    const updateItemForm = (index, val) => {
      const selectedOption = this.optionsProduct.find(option => option.value === val);
      if (selectedOption) {
        // Update the relevant fields
        this.invoiceData.items[index].id = selectedOption.value;
        this.invoiceData.items[index].name = selectedOption.itemTitle;
        this.invoiceData.items[index].qty = this.invoiceData.items[index].qty || 1;
      }
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      HasPermission,
      PermissionList,
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      ServiceTemplateObject: "serviceOne",
      documents: "servicerequestDocuments",
      staffList: "stafflistrequests",
      file: "file",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      productID: "productID",
      loading: "loading",
    }),
    selectedStaff: {
      get() {
        if (this.staffpopulate.length && this.ServiceTemplateObject.staffId) {
          const staffIds = this.ServiceTemplateObject.staffId.split(",");
          return this.staffpopulate.filter((staff) =>
            staffIds.includes(staff.id)
          );
        }
        return [];
      },
      set(value) {
        this.ServiceTemplateObject.staffId = value
          .map((staff) => staff.id)
          .join(",");
      },
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
</style>

<style lang="scss">
.form-item-section {
  //  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}
.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    // background-color: $theme-dark-body-bg;

    .row .border {
      //    background-color: $theme-dark-card-bg;
    }
  }
}
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}
.repeater-form {
  overflow: visible;
  transition: 0.35s height;
  margin: 0;
  padding: 0;
}

.repeater-form > .row {
  margin-bottom: 0;
}
</style>
